import React from 'react';
import { Typography } from '@material-ui/core';

import '../../components/Status.css';

interface Props {}

const Cancel: React.FC<Props> = props => {
  return (
    <div className="Confirmation">
      <div className="content">
        <Typography variant="h4">Canceled</Typography>
        <Typography variant="body2">The order has been canceled.</Typography>
      </div>
    </div>
  );
};

export default Cancel;
